<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div
          class="col-24 col-md-16 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('progTitle')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('pentestSubTitle')" class="pb-2"></span>
            </h1>
            <div v-if="listPentest.length" class="col-8 mb-2 input-group">
              <multiselect
                v-model="listFilterSelected"
                :options="listFilter"
                :searchable="false"
                label="name"
                :close-on-select="true"
                :custom-label="nameFilter"
                :show-labels="false"
                :allow-empty="false"
                :preselect-first="true"
                :multiple="false"
              >
              </multiselect>
            </div>
            <div v-if="loading" class="loading d-flex col-24 mb-4">
              <div class="c-loader"></div>
            </div>
            <div
              class="card col py-3 text-center mb-4"
              v-if="!loading && !listPentest.length"
            >
              <h6 class="p-1" v-text="$ml.get('noPentestAvailable')">
                Nenhum pentest disponível
              </h6>
            </div>
            <div class="mb-3" v-show="listPentest.length">
              <div class="card">
                <div class="card-header" v-text="$ml.get('pentest') + 's'">
                  Pentest
                </div>
                <ListPentest :list-pentest="listPentest" @updateList="getListPentest" />
              </div>
            </div>
            <div v-show="totalPages > 10 && !loading" class="mb-2">
              <b-pagination
                v-model="pageActive"
                :total-rows="totalPages"
                :per-page="10"
                :prev-text="$ml.get('previous')"
                :next-text="$ml.get('next')"
                align="right"
              >
              </b-pagination>
            </div>
            <cardCreatePentest />
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import _ from "lodash";
import cardCreatePentest from "../../../components/cardCreatePentest.vue";
import ListPentest from "../../../components/ListPentestComponent.vue";
import PentestService from "../../../services/pentest.service";
export default {
  components: {
    ListPentest,
    cardCreatePentest,
  },
  data() {
    return {
      loading: false,
      listPentest: [],
      pageActive: 1,
      pageSize: 10,
      totalPages: 0,

      listFilterSelected: { name: "all", id: "" },
      listFilter: [
        { name: "all", id: "" },
        { name: "pending", id: "pending" },
        { name: "canceled", id: "canceled" },
        { name: "approved", id: "approved" },
        { name: "finished", id: "done" },
        { name: "in_progress", id: "in_progress" },
        { name: "under_review", id: "review" },
      ],
    };
  },

  mounted() {
    this.getListPentest();
  },
  watch: {
    pageActive() {
      this.getListPentest();
    },

    listFilterSelected: function () {
      this.getListPentest();
    },
  },
  methods: {
    waitAPI: _.debounce(function () {
      this.getListPentest();
    }, 500),

    nameFilter({ name }) {
      return `${this.$ml.get(name)}`;
    },

    formatObj(obj) {
      return obj?.map((item) => ({
        ...item,
        show_message: false,
      }));
    },

    async getListPentest() {
      try {
        this.loading = true;
        const { data } = await PentestService.getListPentest(
          this.pageActive,
          this.pageSize,
          this.listFilterSelected.id,
        );
        const { items, total } = data;
        this.listPentest = this.formatObj(items);
        this.totalPages = total;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
  },
};
</script>
